import { Pipe, PipeTransform } from '@angular/core';

@Pipe({ name: 'underscoreToLower' })
export class UnderscoreToLowerPipe implements PipeTransform {
  transform(value: string): string {
    if (!value) return '';

    return value
      .replace(/_/g, ' ')
      .toLowerCase()
      .replace(/^./, char => char.toUpperCase());
  }
}
